import {
  SELECTED_CATEGORY_TO_TEMPLATE_TYPE_MAP,
  type SelectedCategory,
} from "../TemplateContents";

export const useNavigation = ({
  selectedCategory,
  onSelectCategory,
  onResetContentType,
}: {
  selectedCategory: SelectedCategory;
  onSelectCategory: (id: SelectedCategory) => void;
  onResetContentType: () => void;
}) => {
  const navigationItems = Object.keys(
    SELECTED_CATEGORY_TO_TEMPLATE_TYPE_MAP,
  ) as SelectedCategory[];

  const onClickNavItem = (id: SelectedCategory) => {
    onSelectCategory(id);
    onResetContentType();
  };

  return {
    activeId: selectedCategory,
    navigationItems,
    onClickNavItem,
  };
};
